import { render, staticRenderFns } from "./CustomCommunity.vue?vue&type=template&id=a10d69ca&"
import script from "./CustomCommunity.vue?vue&type=script&lang=js&"
export * from "./CustomCommunity.vue?vue&type=script&lang=js&"
import style0 from "./CustomCommunity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports